import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * CardLogCreateEvent
 *
 * - Evento emitido quando o um log de card é criado.
 */
export class CardLogCreateEvent extends CreateCommand(RealtimeEventType.CardLogCreate, SCHEMA) {}
